import {GiftIcon} from '@/_application/icons/gift/gift';
import {
    isHotProduct,
    isNewProduct,
    isProductHasGift,
    isSaleProduct,
    Product,
} from '@/_application/modules/products/model/product';
import cn from 'classnames';
import {SalesPercent} from '@/_application/modules/products/components/labels/sale-percent';
import {Tag, RoundedVariant} from '@kidslabs/mario-ui-nextjs-react-core';

export type ProductLabelType = 'sale' | 'hot' | 'new' | 'gift';

interface LabelProps {
    size?: 'small' | 'medium' | 'large' | 'extra-large';
    product: Product;
    saleLabel?: 'text' | 'percent';
    hiddenLabels?: ProductLabelType[];
}

export const ProductLabel = ({size = 'medium', product, saleLabel = 'text', hiddenLabels}: LabelProps) => {
    const isLabelHidden = (label: string) => {
        return !!hiddenLabels?.includes(label as ProductLabelType);
    };

    const labels = ['sale', 'hot', 'new', 'gift'].filter(label => {
        switch (label) {
            case 'sale':
                return isSaleProduct(product) && !isLabelHidden(label);
            case 'hot':
                return isHotProduct(product) && !isLabelHidden(label);
            case 'new':
                return isNewProduct(product) && !isLabelHidden(label);
            case 'gift':
                return isProductHasGift(product) && !isLabelHidden(label);
            default:
                return false;
        }
    });

    return (
        <div className="flex flex-col space-y-1">
            {labels.map((label, index) => {
                const roundedVariant = index === 0 ? RoundedVariant.DIAGONAL : RoundedVariant.LEFT;
                const isPercentLabel = label === 'sale' && saleLabel === 'percent';
                const isGiftLabel = label === 'gift';

                let labelComponent = <p>{label}</p>;
                if (isGiftLabel) {
                    labelComponent = (
                        <GiftIcon
                            className={cn({
                                'h-4 w-4': size === 'large',
                                'h-3.5 w-3.5': size === 'small',
                            })}
                        />
                    );
                } else if (isPercentLabel) {
                    labelComponent = <SalesPercent product={product} />;
                }
                return (
                    <Tag
                        key={`${label}_${index}`}
                        size={size}
                        roundedVariant={roundedVariant}
                        className="bg-KPZ_red text-xs font-bold capitalize text-white">
                        {labelComponent}
                    </Tag>
                );
            })}
        </div>
    );
};
